<div class="dashboard-session-heading">Trade History</div>

<div class="date-from ml-10">Dates between:</div>
<form [formGroup]="chooseDate" class="d-flex align-items-center ml-10 mb-10">
  <div class="date-picker--wrapper">
    <mat-form-field>
      <input matInput [matDatepicker]="startDateHistory" (dateChange)="startDateHistoryChange()" formControlName="pgstartDateHistory"
        (click)="togglePicker(startDateHistory)" [max]="today" readonly />
      <mat-datepicker-toggle panelClass="greengo" matSuffix [for]="startDateHistory"></mat-datepicker-toggle>
      <mat-datepicker panelClass="greengo" #startDateHistory></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="text-between">and</div>
  <div class="date-picker--wrapper">
    <mat-form-field>
      <input matInput [matDatepicker]="endDateHistory" (dateChange)="endDateHistoryChange()" formControlName="pgendDateHistory"
        (click)="togglePicker(endDateHistory)" [max]="today" readonly />
      <mat-datepicker-toggle panelClass="greengo" matSuffix [for]="endDateHistory"></mat-datepicker-toggle>
      <mat-datepicker panelClass="greengo" #endDateHistory></mat-datepicker>
    </mat-form-field>
  </div>
</form>

<div class="align-items-end ml-10 d-none d-md-flex">
  <div class="left-panel">
    <div class="d-flex">
      <div class="btn-chart btn-chart-view" (click)="navigateToTradeHistory()">
        View detailed
        <br> information
      </div>
    </div>
    <div class="d-flex">
      <div class="btn-chart btn-chart-download" (click)="downloadFile()">
        Download
      </div>
    </div>

  </div>
  <div class="chart">
    <ngx-charts-bar-vertical-stacked [scheme]="colorScheme" [results]="chartData" [legend]="false" [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel" (select)="onSelect($event)" [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxis]="true"
      [yAxis]="true" [roundDomains]="false" [rotateXAxisTicks]="0" [barPadding]="barPadding">

      <ng-template #tooltipTemplate let-model="model">
        <div *ngIf="model.value > 0" class="{{model.extra.class}}">
          <div>Total = {{model.value}}</div>
          <div *ngIf="model.extra.gbp > 0">GBP = {{ model.extra.gbp }}</div>
          <div *ngIf="model.extra.eur > 0">EUR = {{ model.extra.eur }}</div>
          <div *ngIf="model.extra.usd > 0">USD = {{ model.extra.usd }}</div>
          <div *ngIf="model.extra.other > 0">Others = {{ model.extra.other }}</div>
        </div>
      </ng-template>
    </ngx-charts-bar-vertical-stacked>
  </div>
</div>

<div class="d-block d-md-none graph-xs">
  <div class="chart-mobile">
    <ngx-charts-bar-vertical-stacked [scheme]="colorScheme" [results]="chartData" [legend]="false" (select)="onSelect($event)"
      [showXAxisLabel]="false" [showYAxisLabel]="false" [xAxis]="true" [yAxis]="true" [roundDomains]="false" [rotateXAxisTicks]="0"
      [barPadding]="5">

      <ng-template #tooltipTemplate let-model="model">
        <div *ngIf="model.value > 0" class="{{model.extra.class}}">
          <div>Total = {{model.value}}</div>
          <div *ngIf="model.extra.gbp > 0">GBP = {{ model.extra.gbp }}</div>
          <div *ngIf="model.extra.eur > 0">EUR = {{ model.extra.eur }}</div>
          <div *ngIf="model.extra.usd > 0">USD = {{ model.extra.usd }}</div>
          <div *ngIf="model.extra.other > 0">Others = {{ model.extra.other }}</div>
        </div>
      </ng-template>
    </ngx-charts-bar-vertical-stacked>
  </div>
  <div class="d-flex justify-content-center">
    <div class="left-note note d-flex align-items-center">
      <div class="circle"></div>
      <div class="text">Settled</div>
    </div>
    <div class="note d-flex align-items-center">
      <div class="circle"></div>
      <div class="text">Outstanding</div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <div class="btn-chart btn-chart-view" (click)="navigateToTradeHistory()">
      View detailed
      <br> information
    </div>
    <div class="btn-chart btn-chart-download" (click)="downloadFile()">
      Download
    </div>
  </div>
</div>

<div class="d-md-flex d-none justify-content-center">
  <div class="left-note note d-flex align-items-center">
    <div class="circle"></div>
    <div class="text">Settled</div>
  </div>
  <div class="note d-flex align-items-center">
    <div class="circle"></div>
    <div class="text">Outstanding</div>
  </div>
</div>